export default __webpack_public_path__ + "static/media/cleanproMigrationBanner.6f00ed42.jpg";